import { ChangeDetectorRef, Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormService } from '../../form.service';
import { Option } from '../../interfaces/option-interface';
import { BaseControlValueAccessorComponent } from '../base-control-value-accessor/base-control-value-accessor.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSelectComponent),
      multi: true,
    },
  ],
})
export class FormSelectComponent extends BaseControlValueAccessorComponent implements OnInit, OnDestroy {
  @ViewChild('dropdown') dropdown: ElementRef;
  @Input() options: Option[] = [];
  @Input() customOptionEnabled: boolean | undefined = false;
  @Input() formControl = new UntypedFormControl();
  @Input() required: boolean | undefined = false;
  @Input() width = 50;
  @Input() placeholder: string | undefined = this.translate.instant('placeholders.pleaseSelect');
  egyeb = { id: 'egyeb', text: 'Egyéb' };
  selectedValues = '';
  id = 0;
  formSub = new Subscription();
  otherOptionInputShown = false;
  dropDownOpen = false;
  selectedOptions: Option[] = [];
  text = '';

  constructor(
    public formService: FormService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly renderer: Renderer2,
    private readonly translate: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.formControl.value) {
      this.selectedOptions = this.formControl.value;
      const filtedArray: Option[] = this.selectedOptions.filter((s) => s.id.length > 2);
      if (filtedArray.length) {
        this.id = +filtedArray[filtedArray.length - 1].id;
      }
      this.selectedOptions.forEach((opt) => {
        if (opt.text === undefined) {
          const index = this.options.findIndex((o) => o.id === opt.id);
          opt.text = this.options[index].text;
        }
        if (!this.options.some((o) => o.id === opt.id)) {
          this.options.push(opt);
        }
      });
      this.formControl.markAsDirty();
      const stringValues = this.selectedOptions.map((s) => {
        return s.text;
      });
      this.selectedValues = stringValues.join(', ');
    }

    this.formSub = this.formControl.valueChanges.subscribe((selectVal) => {
      if (selectVal === null) {
        this.otherOptionInputShown = false;
      }
      this.cdRef.detectChanges();
    });

    this.renderer.listen('document', 'click', (event: Event) => {
      const isClickedInside = this.dropdown.nativeElement.contains(event.target);

      if (!isClickedInside) {
        this.dropDownOpen = false;
      }
    });

    if (this.required) {
      this.placeholder += ' *';
    }
  }

  ngOnDestroy(): void {
    this.formSub.unsubscribe();
  }

  isSelected(id: string): boolean {
    return this.selectedOptions.some((opt) => opt.id === id);
  }

  openDropdown(event: Event): void {
    event.preventDefault();
    this.dropDownOpen = !this.dropDownOpen;
  }

  selectOption(event: Event, option: Option): void {
    event.preventDefault();
    if (this.formControl.disabled) {
      return;
    }

    if (option.id === 'egyeb') {
      this.otherOptionInputShown = true;
      this.formControl.setValue('');
      return;
    }

    if (this.selectedOptions.some((opt) => opt.id === option.id)) {
      this.selectedOptions = this.selectedOptions.filter((opt) => opt.id !== option.id);
      if (this.selectedOptions.length === 0) {
        this.selectedValues = '';
        this.formControl.setValue(null);
        return;
      }
      const stringValues = this.selectedOptions.map((s) => {
        return s.text;
      });
      this.formControl.setValue(this.selectedOptions);
      this.selectedValues = stringValues.join(', ');
      return;
    }
    this.selectedOptions.push({ id: option.id, text: option.text });

    this.formControl.setValue(this.selectedOptions);
    const stringValues = this.selectedOptions.map((s) => {
      return s.text;
    });
    this.selectedValues = stringValues.join(', ');
  }
  nullOutValue(): void {
    this.otherOptionInputShown = false;
    this.formControl.setValue(this.selectedOptions);
  }
  acceptAndAddValueToTheMasses(): void {
    this.otherOptionInputShown = false;
    const value = this.formControl.value;
    if (!value.length) {
      return;
    }
    const newOpttion = { id: this.id.toString(), text: value };
    this.options.push(newOpttion);
    this.selectedOptions.push(newOpttion);
    this.formControl.setValue(this.selectedOptions);
    const stringValues = this.selectedOptions.map((s) => {
      return s.text;
    });
    this.selectedValues = stringValues.join(', ');
    this.id = this.id + 1;
  }
}
